<template>
  <div class="p-3" id="customer-info">

    <el-dialog append-to-body :visible.sync="configNoteVisible" width="700px">
      <NoteConfig />
    </el-dialog>


    <div v-for="(item,ind) in data" :key="ind">
      <div class="mt-1 font-size-14 fw-semibold"> {{ item.title }}</div>
      <el-input
        v-model="item.value"
        type="textarea"
        :autosize="{ minRows: 1, maxRows: 6 }"
        class="mt-1" />
      <div
        v-if="extractUrls(item.value).length"
        class="mt-1 d-flex flex-wrap gap-1">
        <a
          v-for="(url, i) in extractUrls(item.value)"
          :key="i"
          :href="url"
          target="_blank"
          rel="noopener noreferrer"
          class="note-link-chip">
          <i class="el-icon-link me-1" />
          <span class="text-1-line">{{ url }}</span>
        </a>
      </div>
    </div>
    <div class="d-flex justify-content-end mt-2">
      <el-button icon="el-icon-setting" size="small" @click="configNote()">Thiết lập</el-button>
      <el-button type="primary" icon="el-icon-folder" size="small" @click="save">Lưu</el-button>

    </div>
  </div>

</template>
<script>
import NoteConfig from "@/components/NoteConfig";

export default {
  components: { NoteConfig },
  props: ["conversation"],
  watch: {
    conversation: function() {
      this.getInfo();
    }
  },
  data() {
    return {
      historyNoteVisible: false,
      configNoteVisible: false,
      data: []
    };
  },
  methods: {
    extractUrls(text) {
      if (!text || typeof text !== "string") return [];
      const re = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+)/gi;
      const matches = text.match(re) || [];
      return matches.map((u) => (u.startsWith("http") ? u : "https://" + u));
    },
    configNote() {
      this.configNoteVisible = true;
    },
    getInfo() {
      this.data = [];
      this.$http.get("/api/v2/customer/getInfo", {
        params: {
          accountId: this.conversation.accountId,
          toId: this.conversation.toId,
          conversationId: this.conversation.id
        }
      })
        .then(resp => {
          let dt = resp.data;
          this.app.customerCodeList.forEach(b => {
            if (!b.hidden) {
              let p = {
                index: b.index,
                title: b.title,
                value: null,
                cid: 0,
                conversationId: this.conversation.id,
                id: b.id,
                type: b.type,
              };
              let f = dt.find(t => t.code == b.id);
              if (f) {
                p.value = f.value;
                p.cid = f.id;
              }
              this.data.push(p);
            }
          });
          this.data.sort((a, b) => a.index - b.index);
          console.log(this.data);
        });
    },
    save() {
      this.$http.post("/api/v2/customer/save", { "info": this.data })
        .then(() => {
          this.alert("success", "Cập nhật thành công.");
        })
        .catch((ex) => {
          this.alert("error", ex.error ? ex.error.message : "Có lỗi xảy ra.");
        });
    }

  },
  created() {
    this.getInfo();
    this.$bus.$on("closeNoteConfig", () => {
      this.configNoteVisible = false;
      this.getInfo();
    });
  }
};
</script>
<style scoped>
.el-form-item {
  margin-bottom: 15px;
}
.note-link-chip {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 2px 8px;
  font-size: 12px;
  color: #0a58c0;
  background: #eaf0fc;
  border-radius: 12px;
  text-decoration: none;
}
.note-link-chip:hover {
  background: #d9e4f7;
  text-decoration: underline;
}
.note-link-chip .text-1-line {
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
